export default "__VITE_ASSET__JJ66k7HS__"